/** @jsx jsx */
import { jsx } from 'theme-ui'
import { string } from 'prop-types'

const ProgressCircle = ({ stepStatus, ...props }) => {
  // forest is background color for 'inProgress' status
  let stepColor = 'forest'

  switch (stepStatus) {
    case 'notStarted':
      stepColor = 'silver'
      break
    case 'completed':
      stepColor = 'forest20'
      break
  }

  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      sx={{ fill: stepColor }}
      {...props}
    >
      <circle cx="16" cy="16" r="16" />
    </svg>
  )
}

ProgressCircle.propTypes = {
  stepStatus: string,
}

export default ProgressCircle
